import React from 'react';
import { Tag } from 'antd';

// Chuẩn hóa code phục vụ so sánh; danh sách code hợp lệ vẫn chỉ lấy từ master data API.
export const serviceGroupCodeKey = code => String(code || '').toUpperCase();

let registeredServiceGroups = [];

const normalizeServiceGroups = (items) => {
    if (!Array.isArray(items)) return [];

    return items
        .filter(item => item && (item.id || item.value))
        .map(item => ({
            id: item.id || item.value,
            code: item.code || String(item.value || ''),
            name: item.name || item.label || item.code,
            label: item.name || item.label || item.code,
            value: item.id || item.value,
            color: item.color || 'default',
            status: item.status,
        }));
};

export const registerServiceGroups = (items) => {
    registeredServiceGroups = normalizeServiceGroups(items);
    return registeredServiceGroups;
};

export const getServiceGroups = (config) => {
    if (Array.isArray(config?.service_groups)) {
        return normalizeServiceGroups(config.service_groups);
    }

    return registeredServiceGroups;
};

export const getServiceGroupCode = (value) => {
    if (!value) return null;

    if (typeof value === 'object') {
        return value.code ? String(value.code).toUpperCase() : null;
    }

    const matched = registeredServiceGroups.find(item => (
        String(item.value) === String(value) ||
        String(item.code).toUpperCase() === String(value).toUpperCase()
    ));

    return matched ? String(matched.code).toUpperCase() : null;
};

export const isServiceGroup = (value, code) => getServiceGroupCode(value) === code;

export const getServiceGroupItem = (value) => {
    if (value && typeof value === 'object') {
        return {
            id: value.id,
            code: value.code,
            name: value.name || value.label || value.code,
            label: value.name || value.label || value.code,
            value: value.id,
            color: value.color || 'default',
            status: value.status,
        };
    }
    const code = getServiceGroupCode(value);

    if (!code) return null;

    return registeredServiceGroups.find(
        item => String(item.code).toUpperCase() === code
    ) || null;
};

export const getServiceGroupLabel = (value) => {
    const item = getServiceGroupItem(value);

    return item?.label || value || '';
};

export const getServiceGroupColor = (value) => {
    const item = getServiceGroupItem(value);

    return item?.color || 'default';
};

export function renderServiceGroup(value) {
    const item = getServiceGroupItem(value);

    if (!item) return null;

    return (
        <Tag style={{ border: 'none' }} color={item.color}>
            {item.label}
        </Tag>
    );
}
